const testimonialApi = [

    {
        id:1,
        title:"Cha Ji-Hun",
        img: "./assets/main-section1.png",
        company: "Co-founder of Forpeople",
        description: "A visual guide could be a wireframe, creative composition, or information architecture. A device that enables collaboration will lessen the chance of work having to be completely redone. A manager could create a visual guide for the team to complete the build-out."
    },
    {
        id:2,
        title:"Henry Itondo",
        img: "./assets/main-section1.png",
        company: "Co-founder of Source DS",
     description: "A visual guide could be a wireframe, creative composition, or information architecture. A device that enables collaboration will lessen the chance of work having to be completely redone. A manager could create a visual guide for the team to complete the build-out."
    },
    {
        id:3,
        title:"Cha Ji-Hun",
        img: "./assets/main-section1.png",
        company: "Co-founder of Forpeople",
        description: "A visual guide could be a wireframe, creative composition, or information architecture. A device that enables collaboration will lessen the chance of work having to be completely redone. A manager could create a visual guide for the team to complete the build-out."
    },
    {
        id:4,
        title:"Henry Itondo",
        img: "./assets/main-section1.png",
        company: "Co-founder of Source DS",
     description: "A visual guide could be a wireframe, creative composition, or information architecture. A device that enables collaboration will lessen the chance of work having to be completely redone. A manager could create a visual guide for the team to complete the build-out."
    },
    {
        id:1,
        title:"Cha Ji-Hun",
        img: "./assets/main-section1.png",
        company: "Co-founder of Forpeople",
        description: "A visual guide could be a wireframe, creative composition, or information architecture. A device that enables collaboration will lessen the chance of work having to be completely redone. A manager could create a visual guide for the team to complete the build-out."
    },
    {
        id:6,
        title:"Henry Itondo",
        img: "./assets/main-section1.png",
        company: "Co-founder of Source DS",
     description: "A visual guide could be a wireframe, creative composition, or information architecture. A device that enables collaboration will lessen the chance of work having to be completely redone. A manager could create a visual guide for the team to complete the build-out."
    },

]
export default testimonialApi;